/**
 * Builds a user-friendly text representing the current column based filter setting.
 */
class RangeSummaryService {

    getSummary(searchValues: DisguiseDto.SearchValues[]): string {
        let result = '';

        const positives = [];
        const negatives = [];

        for (const currentSearchValue of searchValues) {
            if (currentSearchValue.negate) {
                negatives.push(currentSearchValue);
            } else {
                positives.push(currentSearchValue);
            }
        }

        if (positives.length) {
            result += '(';
        }
        result += this.joinPositives(positives);
        if (positives.length) {
            result += ')';
        }

        if (positives.length && negatives.length) {
            result += ' & ';
        }
        result += this.joinNegatives(negatives);

        return result;
    }

    private joinPositives(positives: DisguiseDto.SearchValues[]) {
        let result: string = '';
        for (let currentSearchValueIndex = 0;
             currentSearchValueIndex < positives.length;
             currentSearchValueIndex++) {
            if (currentSearchValueIndex > 0) {
                result += ', ';
            }
            const currentSearchValue = positives[currentSearchValueIndex];
            result = this.join(result, currentSearchValue);

        }
        return result;
    }

    private joinNegatives(negatives: DisguiseDto.SearchValues[]) {
        let result: string = '';
        for (let currentSearchValueIndex = 0;
             currentSearchValueIndex < negatives.length;
             currentSearchValueIndex++) {
            if (currentSearchValueIndex === 0) {
                result += '!';
            } else if (currentSearchValueIndex <= negatives.length - 1) {
                result += ' & !';
            }
            const currentSearchValue = negatives[currentSearchValueIndex];
            result = this.join(result, currentSearchValue);
        }
        return result;
    }

    private join(result: string, currentSearchValue: DisguiseDto.SearchValues) {
        result += currentSearchValue.equal !== undefined ? currentSearchValue.equal : '';
        if (currentSearchValue.min !== undefined && currentSearchValue.max !== undefined) {
            result += '"' + currentSearchValue.min + '"' + '-' + '"' + currentSearchValue.max + '"';
        } else if (currentSearchValue.min !== undefined) {
            result += '"' + currentSearchValue.min + '"' + '-...';
        } else if (currentSearchValue.max !== undefined) {
            result += '...-' + '"' + currentSearchValue.max + '"';
        }
        return result;
    }
}

const RANGE_SUMMARY_SERVICE_INSTANCE = new RangeSummaryService();

export {RANGE_SUMMARY_SERVICE_INSTANCE};
